export const LOADING_EVALUATION_ACCEPT = "LOADING_EVALUATION_ACCEPT";
export const GET_EVALUATION_ACCEPT = "GET_EVALUATION_ACCEPT";
export const FORM_FAIL = "FORM_FAIL";
export const EVALUATION_ACCEPT_FAIL = "EVALUATION_ACCEPT_FAIL";
